import { useState } from "react";
import Modal from "react-bootstrap/Modal";

export const ViewPTAModelsPublish = () => {
  const [show, setShow] = useState(true);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Modal
        className="my_modal xl"
        show={show}
        onHide={handleClose}
        centered
        size={"xl"}
      >
        <Modal.Header closeButton>
          <Modal.Title>PTA 레벨 전체보기</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="fiter_wrap no-shadow border-0 p-0">
            <div className="row mb-15px">
              <div className="col-6">
                <div className="frm_row search justify-content-start">
                  <label htmlFor="" className="form-label frm_label">
                    검색어
                  </label>
                  <select className="form-select">
                    <option>ERP 전체보기</option>
                  </select>
                  <input className="form-control" value={"효성티앤에스"} />
                </div>
              </div>
              <div className="col-6">
                <div className="frm_row">
                  <label htmlFor="" className="form-label frm_label">
                    날짜
                  </label>
                  <div className="frm_row search justify-content-start">
                    <select className="form-select">
                      <option>2025</option>
                    </select>
                    <select className="form-select">
                      <option>02</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <div className="frm_row search justify-content-start">
                  <label htmlFor="" className="form-label frm_label">
                    품목명
                  </label>
                  <input className="form-control" value={"전체"} />
                </div>
              </div>
              <div className="col-6">
                <div className="frm_row search justify-content-between">
                  <div className="d-flex">
                    <div className="frm_row search justify-content-start">
                      <label htmlFor="" className="form-label frm_label">
                        규격
                      </label>
                      <input className="form-control" value={"전체"} />
                    </div>
                  </div>
                  <button className="btn btn-info btn_search">
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/mds/assets/images/icon_search.png"
                      }
                      alt=""
                    />
                    조회
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="table_top">
            <h6 class="table_stats">품목 제품 상세보기</h6>
          </div>
          <div className="table_scroll">
            <table className="table table-bordered my_table table_modal m-0">
              <thead>
                <tr>
                  <th style={{ width: "4.53%" }}>No</th>
                  <th style={{ width: "14.56%" }}>기준</th>
                  <th style={{ width: "12.94%" }}>ERP거래처명</th>
                  <th style={{ width: "8.09%" }}>Pricing Group</th>
                  <th style={{ width: "8.09%" }}>ERP코드</th>
                  <th style={{ width: "12.94%" }}>Item Name</th>
                  <th style={{ width: "12.94%" }}>End Item Part No.</th>
                  <th style={{ width: "6.47%" }}>a</th>
                  <th style={{ width: "6.47%" }}>b</th>
                  <th style={{ width: "6.47%" }}>c</th>
                  <th>d</th>
                </tr>
              </thead>
              <tbody>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item) => (
                  <tr>
                    <td>{item}</td>
                    <td>FY25 (2024.07 ~ 2025.06)</td>
                    <td>효성티앤에스(주)</td>
                    <td>B</td>
                    <td>310</td>
                    <td>Win Embedded Std C</td>
                    <td>2QG-00003</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="pagination-container">
            <ul>
              <li className="pg_nav">
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                  alt="First Page"
                  className=""
                />
              </li>
              <li className="pg_nav">
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                  alt="Previous Page"
                  className=""
                />
              </li>
              <li className="active">1</li>
              <li className="">2</li>
              <li className="">3</li>
              <li className="">4</li>
              <li className="">5</li>
              <li className="pg_nav">
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                  alt="Next Page"
                  className=""
                />
              </li>
              <li className="pg_nav">
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                  alt="Last Page"
                  className=""
                />
              </li>
            </ul>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
